var _excluded = ["title", "okText", "okButtonProps", "onOk", "className", "getPopper", "children", "icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { classnames } from '@okee-uikit/react-utils';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { Button } from '../button';
import { Content } from '../util/Content';
import { Popover } from './Popover';
export function PopoverAlert(props) {
  var title = props.title,
      okText = props.okText,
      okButtonProps = props.okButtonProps,
      onOk = props.onOk,
      className = props.className,
      getPopper = props.getPopper,
      children = props.children,
      icon = props.icon,
      extra = _objectWithoutProperties(props, _excluded);

  var onOkCallback = useRefCallback(onOk);
  var cls = classnames(usePrefixCls('alert'), className);
  var localeOK = useLocale('popover.ok');
  var okCls = usePrefixCls('alert-ok');
  var footerCls = usePrefixCls('popover-alert-footer');

  var renderOkBtn = function renderOkBtn() {
    var text = okText || localeOK;
    return React.createElement(Button, _objectSpread(_objectSpread({
      type: "primary",
      size: "xs"
    }, okButtonProps), {}, {
      className: okCls,
      onClick: onOkCallback
    }), text);
  };

  var renderFooter = function renderFooter() {
    return React.createElement("div", {
      className: footerCls
    }, renderOkBtn());
  };

  var renderPopper = function renderPopper(data) {
    return React.createElement(Content, {
      prefixCls: "popover-alert",
      header: title,
      footer: renderFooter,
      icon: icon
    }, typeof getPopper === 'function' ? getPopper(data) : getPopper);
  };

  return React.createElement(Popover, _objectSpread(_objectSpread({}, extra), {}, {
    className: cls,
    getPopper: renderPopper
  }), children);
}